export const tr = {
    groups: 'Gruplarda',
    name: 'Ad',
    preview: 'Önizleme'
};
